export const pagination = {
    firstPage: 1,
    range: 3
};
